import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";

const radarPulse = keyframes`
  0% {
    transform: scale(0.6);
    opacity: 0.6;
  }
  100% {
    transform: scale(1.8);
    opacity: 0;
  }
`;

export const PulseWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 5rem;
  height: 5rem;
`;

export const PulseRing = styled.span<{ $delay: string }>`
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 1px solid ${(p) => p.theme.text.colors.brand};
  animation: ${radarPulse} 2.4s ease-out infinite;
  animation-delay: ${(p) => p.$delay};
  animation-fill-mode: backwards;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0;
  }
`;

export const RadarBadge = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background-color: ${(p) => p.theme.colors.background5};
  color: ${(p) => p.theme.text.colors.brand};
`;
